module.exports = __webpack_public_path__ + "static/media/62.d3bdda4c.jpg";